import React, { useEffect, useState } from "react";
import { motion, useMotionValue, animate } from "framer-motion";

export default function MiniLoader({ progress = null }) {
  const count = useMotionValue(0);
  const [displayProgress, setDisplayProgress] = useState(0);

  useEffect(() => {
    // Si un progrès réel est fourni (API Axios), on s'anime vers cette valeur lissée sur 2s
    // Si aucun progrès n'est fourni, on peut simuler une fausse progression ou rester à 0.
    // L'animation vers "progress" (ou 100 si absent pour simuler un loader global) se fait en 2 secondes mini.
    const target = progress !== null ? progress : 100;

    const controls = animate(count, target, {
      duration: 2,
      ease: "easeOut",
    });

    const unsubscribe = count.on("change", (latest) => {
      setDisplayProgress(Math.round(latest));
    });

    return () => {
      controls.stop();
      unsubscribe();
    };
  }, [progress, count]);

  return (
    <div className="flex flex-col items-center justify-center w-full h-full min-h-[12rem] space-y-5">
      <div className="relative w-16 h-16 flex items-center justify-center">
        {/* Logo Gris d'arrière-plan */}
        <img
          src="/assets/loader/loader.svg"
          alt="Fond"
          className="absolute z-0 w-12 h-12 object-contain opacity-20 grayscale"
        />

        {/* Logo Coloré de premier plan avec masque (clip-path) lié au pourcentage */}
        <img
          src="/assets/loader/loader.svg"
          alt="Chargement"
          className="absolute z-10 w-12 h-12 object-contain drop-shadow-md transition-all duration-300 ease-out"
          style={{ clipPath: `inset(${100 - displayProgress}% 0 0 0)` }}
        />
      </div>

      <motion.p 
        animate={{ opacity: [0.5, 1, 0.5] }}
        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        className="text-sm font-medium text-primary tracking-wider"
      >
        Chargement... {displayProgress}%
      </motion.p>
    </div>
  );
}
